import commonApi from "@/api/common/commonApi";
import { ElMessage } from "element-plus";
import { ref, Ref } from "vue";

export const useImgCode = (form: { img_code_answer: string }) => {
  console.log("🚀 ~ useCode ~ form:", form);
  const onGetImageCode = async () => {
    console.log("获取图片");
    const { data } = await commonApi.GetImageCode();
    const { codeId, img } = data;
    imgCodeState.value.codeId = codeId;
    imgCodeState.value.img = "data:image/png;base64," + img;
  };
  const imgCodeState = ref({
    codeId: "",
    img: "",
  });
  const getParams = async () => {
    if (!form.img_code_answer) throw ElMessage.warning("请输入图形验证码");
    const urlObj = {
      img_code_id: imgCodeState.value.codeId,
      img_code_answer: form.img_code_answer,
    };
    return urlObj;
  };
  return {
    onGetImageCode,
    imgCodeState,
    getParams,
  };
};
